import React, { useState } from "react";
import StarterImg from "../../assets/Images/packageimg/startedimage.png";
import "./Package.css";
import PackagModel from "./PackagModel";

export default function Package() {
  const [isYearly, setIsYearly] = useState(false);

  const monthlyArray = [
    {
      type: "Basic",
      name: "Quiz & Perks",
      price: "599",
      rules: ["Daily Quizzes", "Certificates", "Gift Hampers & Perks"],
      comment: "",
    },
    {
      type: "Pro",
      name: "Placement",
      price: "1299",
      rules: ["5 Placement Drives Per Week"],
      comment:
        "Get an exciting opportunity to sit in Real-time Placement with our Placement Cell Experts which enhance your Company Profile.",
    },
    {
      type: "Premium",
      name: "All In One Combo",
      price: "1899",
      rules: ["AI Accelerate", "Quiz & Perks", "Placement"],
      comment: "",
    },
  ];

  const yearlyArray = [
    {
      type: "Basic",
      name: "Quiz & Perks",
      price: "599",
      rules: ["Daily Quizzes", "Certificates", "Gift Hampers & Perks"],
      comment: "",
    },
    {
      type: "Pro",
      name: "Placement",
      price: "1299",
      rules: ["5 Placement Drives Per Week"],
      comment:
        "Get an exciting opportunity to sit in Real-time Placement with our Placement Cell Experts which enhance your Company Profile.",
    },
    {
      type: "Premium",
      name: "All In One Combo",
      price: "1899",
      rules: ["AI Accelerate", "Quiz & Perks", "Placement"],
      comment: "",
    },
  ];

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  
  return (
    <>
      <button
        onClick={openModal}
        className="px-2 py-1 rounded-[20px] text-white package-button"
        style={{
          background: "linear-gradient(0deg, #0A4D68 8.68%, #05BFDB 140.45%)",
          transition: "all 0.5s",
        }}
      >
        Package
      </button>

      <PackagModel isOpen={modalIsOpen} closeModal={closeModal}>
        
        <div className="mt-3 mb-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mx-5">
          <div className="bg-white shadow-2xl rounded-[25px] p-3">
            <div className="background-image1 flex justify-center pt-6 md:pt-4">
              <h1 className="text-center font-semibold text-white text-2xl">
                Starter
              </h1>
            </div>
            <h1
              className="text-center text-lg font-semibold text-[22px]"
              style={{ fontFamily: "Poppins" }}
            >
              AI Accelerate
            </h1>
            <h1 className="text-[#0889A4] font-bold text-[40px] text-center">
              &#8377;299
            </h1>
            <div className="h-[110px] flex justify-center mt-4 startImg1">
              <img src={StarterImg} alt="Starter Image"></img>
            </div>
            <div className="flex justify-center mt-5">
              <button className="">
                <a
                  href="https://www.gravitonweb.com/Pay/299"
                  className="border border-black rounded-[4px] px-3 py-1 "
                >
                  Get Started
                </a>{" "}
              </button>
            </div>
          </div>

          <div className="bg-white shadow-2xl rounded-[25px] p-3">
            <div className="background-image1 flex justify-center pt-6 md:pt-4">
              <h1 className="text-center font-semibold text-white text-2xl">
                Basic
              </h1>
            </div>
            <h1
              className="text-center text-lg font-semibold text-[22px]"
              style={{ fontFamily: "Poppins" }}
            >
              Quiz & Perk
            </h1>
            <h1 className="text-[#0889A4] font-bold text-[40px] text-center">
              &#8377;599
            </h1>
            <div className="h-[110px] mt-4">
              <div className="px-8">
                <div className="flex">
                  <div>
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div className="pl-3 font-medium text-[12px]">
                    Daily Quizzes
                  </div>
                </div>
                <div className="flex mt-4">
                  <div>
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div className="pl-3 font-medium text-[12px]">
                    Certificates
                  </div>
                </div>
                <div className="flex mt-4">
                  <div>
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div className="pl-3 font-medium text-[12px]">
                    Gift Hambers & Perks
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-5">
            <button className="">
                <a
                  href="https://www.gravitonweb.com/Pay/599"
                  className="border border-black rounded-[4px] px-3 py-1 "
                >
                  Get Started
                </a>{" "}
              </button>
            </div>
          </div>

          <div className="bg-white shadow-2xl rounded-[25px] p-3">
            <div className="background-image1 flex justify-center pt-6 md:pt-4">
              <h1 className="text-center font-semibold text-white text-2xl">
                Pro
              </h1>
            </div>
            <h1
              className="text-center text-lg font-semibold text-[22px]"
              style={{ fontFamily: "Poppins" }}
            >
              Placement
            </h1>
            <h1 className="text-[#0889A4] font-bold text-[40px] text-center">
              &#8377;1299
            </h1>
            <div className="h-[110px] mt-4">
              <p className="text-xs px-10 md:px-4">
                Get an exciting opportunity to sit in Real-time Placement with
                our Placement Cell Experts which enhance your Company Profile.
              </p>
              <div className="flex mt-4 px-8">
                <div>
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="pl-3 font-medium text-[12px]">
                  Gift Hambers & Perks
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-5">
              <button className="">
                <a
                  href="https://www.gravitonweb.com/Pay/1299"
                  className="border border-black rounded-[4px] px-3 py-1 "
                >
                  Get Started
                </a>{" "}
              </button>
            </div>
          </div>

          <div className="bg-white shadow-2xl rounded-[25px] p-3">
            <div className="background-image1 flex justify-center pt-6 md:pt-4">
              <h1 className="text-center font-semibold text-white text-2xl">
                Premium
              </h1>
            </div>
            <h1
              className="text-center text-lg font-semibold text-[22px]"
              style={{ fontFamily: "Poppins" }}
            >
              All In One Combo
            </h1>
            <h1 className="text-[#0889A4] font-bold text-[40px] text-center">
              &#8377;1899
            </h1>
            <div className="h-[110px] mt-4">
              <div className="px-8">
                <div className="flex">
                  <div>
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div className="pl-3 font-medium text-[12px]">
                    AI Accelerate
                  </div>
                </div>
                <div className="flex mt-4">
                  <div>
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div className="pl-3 font-medium text-[12px]">
                    Quiz & Perks
                  </div>
                </div>
                <div className="flex mt-4">
                  <div>
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div className="pl-3 font-medium text-[12px]">Placement</div>
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-5">
               <button className="">
                <a
                  href="https://www.gravitonweb.com/Pay/1899"
                  className="border border-black rounded-[4px] px-3 py-1 "
                >
                  Get Started
                </a>{" "}
              </button>
            </div>
          </div>

          {/* {isYearly && (
            <>
            <div className="bg-white shadow-2xl rounded-[25px] p-3">
                <div className="background-image1 flex justify-center pt-6 md:pt-4">
                  <h1 className="text-center font-semibold text-white text-2xl">
                    Starter
                  </h1>
                </div>
                <h1
                  className="text-center text-lg font-semibold text-[22px]"
                  style={{ fontFamily: "Poppins" }}
                >
                  AI Accelerate
                </h1>
                <h1 className="text-[#0889A4] font-bold text-[40px] text-center">
                  &#8377;299
                </h1>
                <div className="h-[110px] flex justify-center mt-4 startImg1">
                  <img src={StarterImg} alt="Starter Image"></img>
                </div>
                <div className="flex justify-center mt-5">
                  <button className="border border-black rounded-[4px] px-3 py-1 ">
                    Get Started
                  </button>
                </div>
              </div>

              <div className="bg-white shadow-2xl rounded-[25px] p-3">
                <div className="background-image1 flex justify-center pt-6 md:pt-4">
                  <h1 className="text-center font-semibold text-white text-2xl">
                    Basic
                  </h1>
                </div>
                <h1
                  className="text-center text-lg font-semibold text-[22px]"
                  style={{ fontFamily: "Poppins" }}
                >
                  Quiz & Perk
                </h1>
                <h1 className="text-[#0889A4] font-bold text-[40px] text-center">
                  &#8377;599
                </h1>
                <div className="h-[110px] mt-4">
                  <div className="px-8">
                    <div className="flex">
                      <div>
                        <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <div className="pl-3 font-medium text-[12px]">
                        Daily Quizzes
                      </div>
                    </div>
                    <div className="flex mt-4">
                      <div>
                        <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <div className="pl-3 font-medium text-[12px]">
                        Certificates
                      </div>
                    </div>
                    <div className="flex mt-4">
                      <div>
                        <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <div className="pl-3 font-medium text-[12px]">
                        Gift Hambers & Perks
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center mt-5">
                  <button className="border border-black rounded-[4px] px-3 py-1 ">
                    Get Started
                  </button>
                </div>
              </div>

              <div className="bg-white shadow-2xl rounded-[25px] p-3">
                <div className="background-image1 flex justify-center pt-6 md:pt-4">
                  <h1 className="text-center font-semibold text-white text-2xl">
                    Pro
                  </h1>
                </div>
                <h1
                  className="text-center text-lg font-semibold text-[22px]"
                  style={{ fontFamily: "Poppins" }}
                >
                  Placement
                </h1>
                <h1 className="text-[#0889A4] font-bold text-[40px] text-center">
                  &#8377;1299
                </h1>
                <div className="h-[110px] mt-4">
                  <p className="text-xs px-10 md:px-4">
                    Get an exciting opportunity to sit in Real-time Placement
                    with our Placement Cell Experts which enhance your Company
                    Profile.
                  </p>
                  <div className="flex mt-4 px-8">
                    <div>
                      <svg
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <div className="pl-3 font-medium text-[12px]">
                      Gift Hambers & Perks
                    </div>
                  </div>
                </div>
                <div className="flex justify-center mt-5">
                  <button className="border border-black rounded-[4px] px-3 py-1 ">
                    Get Started
                  </button>
                </div>
              </div>

              <div className="bg-white shadow-2xl rounded-[25px] p-3">
                <div className="background-image1 flex justify-center pt-6 md:pt-4">
                  <h1 className="text-center font-semibold text-white text-2xl">
                    Premium
                  </h1>
                </div>
                <h1
                  className="text-center text-lg font-semibold text-[22px]"
                  style={{ fontFamily: "Poppins" }}
                >
                  All In One Combo
                </h1>
                <h1 className="text-[#0889A4] font-bold text-[40px] text-center">
                  &#8377;1899
                </h1>
                <div className="h-[110px] mt-4">
                  <div className="px-8">
                    <div className="flex">
                      <div>
                        <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <div className="pl-3 font-medium text-[12px]">
                        AI Accelerate
                      </div>
                    </div>
                    <div className="flex mt-4">
                      <div>
                        <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <div className="pl-3 font-medium text-[12px]">
                        Quiz & Perks
                      </div>
                    </div>
                    <div className="flex mt-4">
                      <div>
                        <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.17697 6.00009L4.753 8.78388L12.28 0.432733C12.8435 -0.131524 13.729 0.470316 13.2863 1.10983L5.8801 11.6803C5.31656 12.3574 4.55184 12.4327 3.90778 11.7556L0.164462 7.58001C-0.560035 6.6019 1.29145 5.21023 2.17697 6.00008V6.00009Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <div className="pl-3 font-medium text-[12px]">
                        Placement
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center mt-5">
                  <button className="border border-black rounded-[4px] px-3 py-1 ">
                    Get Started
                  </button>
                </div>
              </div>
            </>
          )} */}
        </div>
      </PackagModel>
    </>
  );
}
